var AdLogin = (function () {

    return {
        checkAdIdAndConnect : checkAdIdAndConnect,
        mra: {
            mraActiveXLoginStart: mraActiveXLoginStart,
            mraReplaceUserInfm: mraReplaceUserInfm
        }
    }

    /**
     * @description AD_AUTO_LOGIN 기능키 오픈시에만 동작.
     *              0. 일렉트론 통해서 whoami 가져온 Id로 자동로그인시킴.
     *              1. 기존 자동로그인 동작은 기능키가 켜졌을땐 동작하지 않음.
     */
    function checkAdIdAndConnect(userId, isIntegratedAuth=false) {
        var adUserId;

        if (location.search.indexOf('logout=Y') > -1 && !isIntegratedAuth) {
            return;
        }
        if (!userId) {
            adUserId = getUserIdOnly(ElectronApi.User.getWhoAmI());
            adUserId = getUserIdOnly(ElectronApi.Comm.getConfigs().adId);
            adUserId = adUserId.toUpperCase()
            adUserId = ServerChecker.isHiib ? getUserIdOnly(ElectronApi.User.getUserIdWithNLogin()) : getUserIdOnly(ElectronApi.User.getWhoAmI());
        } else {
            adUserId = userId;
            if(ServerChecker.isBnk) adUserId = userId.toUpperCase();
        }
        createAutoLoginKey(adUserId);
    }

    /**
     * @description split 해야 하는 경우 기업별로 처리.
     *              - develop인 경우 임시아이디로 테스트
     * @param adUserId 처리 전 순수한 whoami /upn
     */
    function getUserIdOnly(adUserId) {
        if (!adUserId) return;

        const adPusanId = "@adpusan";
        const adWelcomeId = "@wsbin.co.kr";
        const isAdPusan = adUserId.indexOf(adPusanId) > -1;
        const isAdWelcome = adUserId.indexOf(adWelcomeId) > -1;

        if (isAdPusan) adUserId = adUserId.split(adPusanId)[0];
        else if (isAdWelcome) adUserId = adUserId.split(adWelcomeId)[0];
        // DEV 테스트용 soytest7 계정 로직 제거
        /*
            웰컴저축은행 회장님 쓰실 아이디 특정 컴퓨터에서 예외처리
            컴퓨터에 로그인 되어 있는 아이디 변경 가능한지 요청하였으나 불가하여 해당 코드로 직접 처리
         */
        if(isAdWelcome && adUserId==="u00001") adUserId="022101";

        return adUserId;
    }

    /**
     * @description adUserId를 받아서
     *              1. 해당 Id의 유저가 user_prfl에 있는지 체크
     *              2. 있으면 1)세션만들고 2)메인으로 이동시킴
     *              3. 없으면 NOTEXIST로 떨어짐. 그럼 리턴. (로그인 페이지 머무름.)
     */
    function createAutoLoginKey(adUserId) {
        if(Often.null2Void(adUserId, "") === "") return;
        Ajax.executeApi(RenewalApi.GET.ACT_AUTO_LOGIN_BY_AD, {
            USER_ID: adUserId,
            OBJ_CNTS_NM: (ElectronApi.Comm.isElectron() ? "desktop" : "")
        }, function (dat) {
            if(Often.null2Void(dat.RESULT_CD, "") === "NOTEXIST") return;
            CommonLogin.createAutoLoginKey(adUserId).then(() => {
                CommonLogin.moveMainPage();
            })
        })
    }
    function mraReplaceUserInfm(mra_user_id) {
        if(Often.null2Void(mra_user_id, "") === "") return;
        const EMP_NO = +mra_user_id;

        Ajax.executeApi(RenewalApi.GET.ACT_GET_ID_BY_EMPNO, {
            EMP_NO
        }, function (dat) {
            if(Often.null2Void(dat.RESULT_CD, "") === "NOTEXIST") return;
            checkAdIdAndConnect(dat.USER_ID, true);
        })
    }
    function mraActiveXLoginStart() {
        var mra_user_id, timer_id, server_status, timer_cnt = 0;
        clearInterval(timer_id);

        try {
            // 로그인한 사번 가져오기
            mra_user_id = MADW_AX.GetLoginToken(''); // 반환값이 base64 인코딩된 값
            mraReplaceUserInfm(atob(mra_user_id));
        } catch (e) {
            // 프로그램이 설치되지 않은 경우
            Often.toast("error", "통합인증 클라이언트 프로그램이 PC 에 설치되지 않았습니다. 프로그램 설치 후 진행해 주십시요.");
            return;
        }

        if (mra_user_id == null || mra_user_id == "") {
            server_status = MADW_AX.GetStatus();

            if (server_status == "RETRY") {
                // TODO : 불분명한 상황이므로 잠시 후 다시 시도 메시지를 출력합니다.
                Often.toast("error", i18next.t(common.errorTryAgain));
                return;
            }
            if (server_status == "EMERGENCY") {
                Often.toast("error", "통합인증 서버에 장애가 발생하였습니다. 비상 로그인 방식으로 전환합니다.");
                // TODO : 장애 상황이므로 ID/PW 입력을 받아서 자체 로그인을 진행합니다.
                return;
            }
            // 로그인이 되지 않은 상태
            timer_id = setInterval(callAuth, 1000);
            //alert("통합인증 되지 않은 상태입니다.");
        } else {
            // TODO : 조회한 사번을 사용하여 로그인을 진행합니다.
            Often.toast("success", "이미 통합인증한 사번:" + mra_user_id);
            return;
        }

// 통합인증을 기다리는 함수
        function callAuth() {
            ret_isLogin = MADW_AX.IsLogin();
            //if (MADW_AX.IsLogin()) {
            if (ret_isLogin == "1") {
                // 로그인한 사번 가져오기
                mra_user_id = MADW_AX.GetLoginToken('');
                server_status = MADW_AX.GetStatus();

                // TODO : 조회한 사번을 사용하여 로그인을 진행합니다.
                Often.toast("success", "통합인증을 완료한 사번:" + mra_user_id);
                clearInterval(timer_id);
            } else if (ret_isLogin == "-1") {
                // 통합인증을 취소한 상태
                Often.toast("error", "통합인증을 취소하였습니다");
                clearInterval(timer_id);
            } else {
                if (timer_cnt >= 120) {
                    // 시간 초과
                    clearInterval(timer_id);
                }
                timer_cnt++;
            }
        }
    }

})();
